import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          click: {
              shopClick: 'menuOpen',
              loginClick: 'loginOpen',
              wishlistClick: 'wishlistOpen',
              searchClick: 'searchOpen',
              cartClick: 'cartToggle',
              sandwichClick: 'sandwichOpen',
          }
        };
        
        this.cartAnimate = this.$('cart')[0].animate([
          { maxHeight: '0px' },
          { maxHeight: '350px' },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.cartAnimate.pause();

        this.cartPrompt = this.$('cart-prompt')[0].animate([
          { opacity: '0' },
          { opacity: '1' },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.cartPrompt.pause();
        
        this.cartToggled = false;
        
    }

    menuOpen(e) {
      this.call('menuOpen', null, 'Sidemenu')
    }

    loginOpen(e) {
      this.call('menuOpen', null, 'Login');
    }

    wishlistOpen(e) {
      this.call('menuOpen', null, 'Wishlist');
    }

    searchOpen(e) {
      this.call('menuOpen', null, 'Search');
    }

    sandwichOpen(e) {
      this.call('menuToggle', null, 'Sidemenumobile');
    }

    cartClickAway(evt) {
      if(this.cartToggled) {
        const cart = this.$('cart')[0];
        let targetEl = evt.target;
  
        do {
          if(targetEl == cart) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        this.cartClose();
      }
    }

    closeCallback() {
      document.removeEventListener("click", this.cartClickAway.bind(this), false);
      this.cartAnimate.reverse();
      this.cartPrompt.reverse();
      this.cartToggled = false;

      this.cartAnimate.finished.then(() => {
        this.cartAnimate.pause();
      })

      this.cartPrompt.finished.then(() => {
        this.cartPrompt.pause();
      })
    }

    cartToggle(e) {
      if(this.cartToggled) {
        this.closeCallback()
      } else {
        this.cartAnimate.playbackRate = 1;
        this.cartPrompt.playbackRate = 1;
        this.cartAnimate.play();
        this.cartPrompt.play();

        this.cartAnimate.finished.then(() => {
          this.cartAnimate.pause();
        })

        this.cartPrompt.finished.then(() => {
          document.addEventListener("click", this.cartClickAway.bind(this), false);
          this.cartToggled = true;
          this.cartPrompt.pause();
        })
      }
      
    }

    cartClose(e) {
      if(this.cartToggled) {
        this.closeCallback()
      } 
    }

}
